/* eslint-disable react/no-array-index-key */
import { Col, Container, Row } from 'react-bootstrap';
import { IconCard } from '../../../Components/Card';
import { SubSectionHeading } from '../../../Components/Headings';
import techWork1 from '../../../assets/images/svg/techwork1.svg';
import techWork2 from '../../../assets/images/svg/techwork2.svg';
import techWork3 from '../../../assets/images/svg/techwork3.svg';
import techWork4 from '../../../assets/images/svg/techwork4.svg';
import techWork5 from '../../../assets/images/svg/techwork5.svg';
import techWork6 from '../../../assets/images/svg/techwork6.svg';
import './howOurTechWorks.css';

const techWorks = [
  {
    image: techWork1,
    title: '1. Light Analysis',
    desc: 'Light from surrounding environment or device torch penetrates the skin and reflects off blood vessels to camera.'
  },
  {
    image: techWork2,
    title: '2. Camera Calibration',
    desc: 'Meri Sehat connects to camera and receives captured video stream. Camera parameters automatically adjust to optimize video feed.'
  },
  {
    image: techWork3,
    title: '3. Luminance Correction',
    desc: 'When required, light levels are processed to improve vital signs accuracy.'
  },
  {
    image: techWork4,
    title: '4. ROI Detection',
    desc: 'Region of interest is cropped from full image.'
  },
  {
    image: techWork5,
    title: '5. RGB Data Extraction',
    desc: 'Skin detection is performed on each ROI followed by extraction of RGB (red, green, blue values).'
  },
  {
    image: techWork6,
    title: '6. Vital Signs Calculations',
    desc: 'Each vital sign is calculated based on varying quantities of data. Results appear within 10 sec. to 1 min.'
  }
];

function HowOurTechWorks() {
  return (
    <section className="howOurTechWorks">
      <Container>
        <SubSectionHeading text="How Our Technology Works" />
        <Row>
          {techWorks.map((techWork, index) => {
            const { image, title, desc } = techWork;
            return (
              <Col md={4} key={index}>
                <IconCard img={image} heading={title} desc={desc} />
              </Col>
            );
          })}
        </Row>
      </Container>
    </section>
  );
}

export default HowOurTechWorks;
